import React from "react";
import { usePageMeta } from "@/lib/usePageMeta";
import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  usePageMeta({
    title: "Ochrana osobních údajů | STK Komfort Znojmo",
    description:
      "Zásady ochrany osobních údajů STK Komfort Znojmo. Jak zpracováváme údaje zákazníků při poptávkách STK, emisí, přepisů a dalších auto služeb.",
    canonical: "https://www.stkkomfort.cz/ochrana-osobnich-udaju",
  });

  return (
    <LegalLayout
      title="Ochrana osobních údajů"
      lead="Tyto zásady popisují, jak STK Komfort™ zpracovává osobní údaje zákazníků a návštěvníků webu v souladu s nařízením GDPR a českými právními předpisy."
    >
      <h2>1. Správce osobních údajů</h2>
      <p>
        Projekt STK Komfort™ je obchodně a agenturně zastřešen společností{" "}
        <strong>UNOEXTREME Capital Group s.r.o.</strong>, IČO 09361430, sídlem
        Děčínská 552/1, Střížkov, 180 00 Praha, datová schránka fy6ewyj. Společnost je
        zapsána u Městského soudu v Praze pod spis. zn. C 442251/MSPH.
      </p>
      <p>
        <em>Pozn. pro provozovatele: Před spuštěním finálně potvrdit, kdo je správcem osobních
        údajů podle smluvního nastavení projektu (zda zastřešující společnost, nebo přímo
        provozovatel služby).</em>
      </p>

      <h2>2. Kontaktní osoba pro zákaznické požadavky</h2>
      <p>
        <strong>Lenka Garguláková</strong><br />
        Telefon: <a href="tel:+420775659129">+420 775 659 129</a><br />
        Kontaktní místo po telefonické domluvě: Sedlešovice 34, Nový Šaldorf — autoopravna
      </p>

      <h2>3. Jaké údaje zpracováváme</h2>
      <ul>
        <li>jméno a příjmení</li>
        <li>telefonní číslo</li>
        <li>e-mailová adresa</li>
        <li>informace o vozidle (značka, model, palivo)</li>
        <li>SPZ / VIN, pokud je zákazník uvede</li>
        <li>požadovaná služba a preferovaný termín</li>
        <li>lokalita vozidla</li>
        <li>obsah zprávy ve formuláři nebo v chatu</li>
        <li>technické údaje o zařízení a návštěvě webu (pouze podle nastavení cookies)</li>
      </ul>

      <h2>4. Účely zpracování</h2>
      <ul>
        <li>vyřízení poptávky a příprava nabídky služby</li>
        <li>komunikace se zákazníkem</li>
        <li>zajištění STK, emisí, evidenční kontroly, přepisu, servisu nebo jiné objednané služby</li>
        <li>plnění smlouvy nebo jednání před uzavřením smlouvy</li>
        <li>plnění zákonných povinností (účetnictví, archivace)</li>
        <li>ochrana oprávněných zájmů (zejména prevence zneužití služby)</li>
        <li>měření návštěvnosti a marketingové vyhodnocování (jen se souhlasem)</li>
      </ul>

      <h2>5. Právní základy zpracování</h2>
      <ul>
        <li>plnění smlouvy / jednání před uzavřením smlouvy (čl. 6 odst. 1 písm. b) GDPR)</li>
        <li>splnění právní povinnosti (čl. 6 odst. 1 písm. c) GDPR)</li>
        <li>oprávněný zájem správce (čl. 6 odst. 1 písm. f) GDPR)</li>
        <li>souhlas (čl. 6 odst. 1 písm. a) GDPR) — u analytických a marketingových cookies</li>
      </ul>

      <h2>6. Komu mohou být údaje předány</h2>
      <ul>
        <li>smluvním partnerům nezbytným pro vyřízení služby</li>
        <li>partnerovi pro STK a emise, zejména <strong>PSOTA Znojmo</strong></li>
        <li>smluvnímu autoservisu pro servisní práce a opravy</li>
        <li>pojišťovacím zprostředkovatelům a pojišťovnám (pokud klient požaduje pojištění)</li>
        <li>odtahové službě</li>
        <li>poskytovateli webu, hostingu, e-mailu, CRM, SMS notifikací (jako zpracovatelům)</li>
        <li>účetním a právním poradcům</li>
        <li>orgánům veřejné moci, pokud to vyžaduje právní předpis</li>
      </ul>
      <p>
        Údaje nejsou předávány do třetích zemí mimo EU/EHP bez odpovídajících záruk.
      </p>

      <h2>7. Doba uchování</h2>
      <ul>
        <li>nevyřízené poptávky: nejdéle 6 měsíců od posledního kontaktu</li>
        <li>smluvní a účetní dokumentace: dle zákonných lhůt (zejména 5–10 let)</li>
        <li>marketingové souhlasy: do odvolání souhlasu</li>
        <li>cookies: podle nastavení uživatele a doby uvedené v Zásadách cookies</li>
      </ul>

      <h2>8. Práva subjektu údajů</h2>
      <ul>
        <li>právo na přístup k osobním údajům</li>
        <li>právo na opravu nepřesných údajů</li>
        <li>právo na výmaz (&bdquo;právo být zapomenut&ldquo;)</li>
        <li>právo na omezení zpracování</li>
        <li>právo na přenositelnost údajů</li>
        <li>právo vznést námitku proti zpracování</li>
        <li>právo kdykoliv odvolat udělený souhlas</li>
        <li>právo podat stížnost u dozorového úřadu</li>
      </ul>

      <h2>9. Kontakt pro uplatnění práv</h2>
      <p>
        Žádosti týkající se osobních údajů můžete uplatnit přes kontaktní formulář na webu,
        telefonicky na <a href="tel:+420775659129">+420 775 659 129</a>, e-mailem na{" "}
        <a href="mailto:info.stkkomfort@gmail.com">info.stkkomfort@gmail.com</a>, nebo písemně na
        adresu kontaktního místa.
      </p>

      <h2>10. Dozorový úřad</h2>
      <p>
        Máte právo podat stížnost u Úřadu pro ochranu osobních údajů, Pplk. Sochora 27, 170 00 Praha 7,{" "}
        <a href="https://www.uoou.cz" target="_blank" rel="noreferrer noopener">www.uoou.cz</a>.
      </p>

      <p className="mt-10 text-xs text-slate-500">
        Tyto zásady jsou platné od data jejich zveřejnění a mohou být průběžně aktualizovány.
        Před ostrým spuštěním webu je doporučena kontrola textu právníkem.
      </p>
    </LegalLayout>
  );
}
